import { i18n, Row, utils, Form, Input } from '@common';
import Clipboard from "clipboard";
import "./index.less";
import { useRef, useState, useEffect } from 'react';
import { transferService } from "@api";
import { routerPaths } from '../../oauth/tool';

const RetrieveCopyStuID = () => {
    const formRef = useRef();
    const [text, setText] = useState('');
    const params = utils.geturlparam(window?.location.search);
    const { obj } = params;
    const cid = decodeURIComponent(obj.cid);

    useEffect(() => {
        window.wogaaCustom?.completeTransactionalService('cispoliteedu-4706');
    });

    useEffect(() => {
        try {
            const copy = new Clipboard('.copy-btn', {
                text: function () {
                    return text;
                }
            });
            copy.on('success', e => {
                $$.toast(i18n.get('CIS_Retrieve_CopySuccess_Message'), 'success');
            });
        } catch (e) {
            $$.toast(i18n.get('CIS_Retrieve_CopyFailed_Message'), 'error');
        }
    }, [text]);

    const handleCopy = (value) => {
        setText(value);
    };

    const handleBackBtn = () => {
        const EmailOTP = false, goBack = true;
        transferService.regetProxyState(obj?.proxyState).then(() => {
            utils.redirectTo(routerPaths.home.compile({ active: "loginStudentID" }), EmailOTP, goBack);
        });
    };
    return (
        <div className='retrieve'>
            {obj?.from === 'retrieveEmailOTP' ?
                <>
                    <div className='title'>{i18n.get('CIS_RetrieveByStudentID_Title_Entry')}</div>
                    <div className='secTitle'>{i18n.get('CIS_Retrieve_Secondary_title_Entry')}</div>
                </>
                :
                <>
                    <div className='title'>{i18n.get('CIS_RetrieveBySingPass_Title_Entry')}</div>
                    <div className='secTitle'>{i18n.get('CIS_Retrieve_Secondary_title_Entry')}</div>
                </>
            }
            <Form ref={formRef}>
                <Row>
                    <R.Button
                        className="copy-btn"
                        text={i18n.get('CIS_Retrieve_Copy_Entry')}
                        classify='info'
                        attrs={{ 'style': 'border-radius: 8px; font-size:18px; height:40px; width:75px; position: absolute; top: 4px; right: 16px;' }}
                        onClick={() => handleCopy(cid)}
                        disabled={cid === 'null' ? true : false}
                    />
                    <Input
                        type="text"
                        value={cid === 'null' ? null : cid}
                        attrs={{ "aria-labelledby": Form.formlabel, "style": "font-size:20px;color:#000" }}
                        id="input-retrieve"
                        disabled
                    />
                    <R.ValidationFaker of="#input-retrieve" valid={cid === 'null' ? false : true} message={i18n.get("CIS_Retrieve_Validatio_Message")} />
                </Row>
                <Row>
                    <R.Button
                        text={i18n.get('CIS_Retrieve_BackToSignin_Entry')}
                        classify='info'
                        block
                        attrs={{ 'style': 'border-radius: 8px; font-size:18px ;height:42px' }}
                        onClick={handleBackBtn}
                    />
                </Row>
            </Form>
        </div>
    );
};

export default RetrieveCopyStuID;